<template>
  <page-container>
    <h3>Monsters</h3>
    <p>Under construction :(</p>
  </page-container>
</template>

<script>

export default {
  name: 'Home',
}
</script>
